import { Check, Close } from '@mui/icons-material';
import { Button, Dialog, Link, Stack, Typography, InputAdornment, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useResetPhysicianDashboardTokenMutation } from '../../api/physicianDashboardSlice';
import { theme } from '../../theme';

function InvalidToken(){
    const [ buttonDisabled, setButtonDisabled ] = useState(false);
    const [ isError, setIsError ] = useState(false);
    const [ phoneNumber, setPhoneNumber ] = useState('');

    const [ resetToken ] = useResetPhysicianDashboardTokenMutation();

    const handleResendToken = async () => {
        await resetToken({
            phoneNumber: '+1' + phoneNumber
        }).unwrap().then(() => {
            setIsError(false);
        }).catch(() => {
            setIsError(true);
        });
        setButtonDisabled(true);
    }

    return (
        <Dialog open>
            <Stack p={4} spacing={2} open>
                <Typography variant='bold' sx={{ fontSize: '1.25rem' }}>
                    We're sorry, it looks like your access link is no longer valid!
                </Typography>
                <Typography sx={{ fontSize: '0.875rem' }}>
                    Please enter your phone number below and we will send you a new access link. If you continue to have trouble, please contact DOCSI support.
                </Typography>
                <TextField value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} placeholder='Enter your phone number' slotProps={{ input: { startAdornment: <InputAdornment position='start'>+1</InputAdornment> } }}/>
                <Button fullWidth variant='blueContained' onClick={handleResendToken} disabled={buttonDisabled}>
                    { !buttonDisabled && 'Resend Link' }
                    { buttonDisabled && isError && <><Close></Close>Error Sending Link</> }
                    { buttonDisabled && !isError && <><Check></Check>Link Sent</> }
                </Button>
                { buttonDisabled && isError && 
                    <Typography sx={{ fontSize: '0.75rem', color: `${theme.palette.red.main}` }}>{'We encountered a problem, please contact '}
                        <Link>support@docsihealth.com</Link> or fill out <Link underline="always" href='https://docs.google.com/forms/d/e/1FAIpQLSdZk2yXi-G7yU_dhUurqcd_id2ffgXYXh46m0tNwW2EJJmD-Q/viewform' target="_blank">
                        this form</Link> for help.
                    </Typography>
                }
                { buttonDisabled && !isError &&
                    <Typography sx={{ fontSize: '0.75rem' }}>{'If you don\'t receive it within five minutes, please fill out '} 
                        <Link underline="always" href='https://docs.google.com/forms/d/e/1FAIpQLSdZk2yXi-G7yU_dhUurqcd_id2ffgXYXh46m0tNwW2EJJmD-Q/viewform' target="_blank">
                        this form</Link> for help.
                    </Typography>
                }
            </Stack>
        </Dialog>
    )
}

export default InvalidToken;